import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="lsat-section"
// Initializes LSAT section form functionality
// Replaces inline script tag in _digital_section_form.html.erb
export default class extends Controller {
  // Removed imageData value - now reading from script tag instead

  // Track if initialization has been done (shared across all instances)
  static initialized = false
  static initializedOnLoad = false
  static resizeHandlerAttached = false

  connect() {
    // Wait for jQuery to be available
    if (typeof window.$ === 'undefined') {
      console.warn('[lsat-section] jQuery not available, retrying...')
      setTimeout(() => this.connect(), 100)
      return
    }

    // Set up window resize handler (only once, using static flag)
    if (!this.constructor.resizeHandlerAttached) {
      window.addEventListener('resize', () => this.resizePage())
      this.constructor.resizeHandlerAttached = true
    }

    // Only initialize once (the form element has the script tag, button doesn't)
    if (this.hasImageData() && !this.constructor.initialized) {
      // Initialize on document ready (equivalent to $(document).ready)
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.initialize())
      } else {
        this.initialize()
      }
      this.constructor.initialized = true
    }

    // Initialize on window load (equivalent to window.onload) - only once, from form instance
    if (this.hasImageData() && !this.constructor.initializedOnLoad) {
      if (document.readyState === 'complete') {
        this.initializeOnLoad()
        this.constructor.initializedOnLoad = true
      } else {
        window.addEventListener('load', () => {
          if (!this.constructor.initializedOnLoad) {
            this.initializeOnLoad()
            this.constructor.initializedOnLoad = true
          }
        })
      }
    }
  }

  // Helper method to check if image data script tag exists
  hasImageData() {
    return document.getElementById('lsat-section-image-data') !== null
  }

  initialize() {
    // Use jQuery if available (for compatibility with existing code)
    const $ = window.$

    // Set up currentQuestion object
    // Must set window.currentQuestion (used by startTest and other controllers)
    const currentQuestionObj = {
      number: 1,
      startTime: 0, // the time that this setup was clicked
      change: function(x) {
        // Use the object itself, not 'this', to match original behavior
        const q = window.currentQuestion || currentQuestionObj;
        q.number = x;
      }
    }

    // Set on window - this is what other controllers will use
    window.currentQuestion = currentQuestionObj

    // Show the first question container on page load (visible but not interactable until start is clicked)
    // Hide all question containers first
    if ($) {
      $(".interface-questions-container-holder-yash").css("display", "none")
      // Show the first question container
      $("#interface-questions-container-holder-1-yash").css("display", "block")

      // Set up the first bubble styling (bold, black indicator)
      $(".interface-bottom-bubble-wrap-yash").css("fontWeight", "normal")
      $(".interface-bottom-bubble-wrap-yash:first").css("fontWeight", 700)
      $(".interface-bottom-current-bubble-yash").removeClass("interface-black-yash")
      $("#interface-bottom-current-bubble-1-yash").addClass("interface-black-yash")

      // For games/comp sections, show the first setup container
      // Get the setup number from the first bubble
      const firstBubble = $(".interface-bottom-bubble-wrap-yash:first")
      const setupNumber = firstBubble.attr("data-setup-number")
      if (setupNumber) {
        $(".interface-setup-container-yash").css("display", "none")
        $("#interface-setup-container-" + setupNumber + "-yash").css("display", "block")
      }
    } else {
      // Fallback without jQuery
      const allContainers = document.querySelectorAll(".interface-questions-container-holder-yash")
      allContainers.forEach(container => {
        container.style.display = "none"
      })
      const firstContainer = document.getElementById("interface-questions-container-holder-1-yash")
      if (firstContainer) {
        firstContainer.style.display = "block"
      }

      // Set up first bubble styling
      const firstBubble = document.querySelector(".interface-bottom-bubble-wrap-yash")
      if (firstBubble) {
        firstBubble.style.fontWeight = "700"
        const firstBubbleIndicator = document.getElementById("interface-bottom-current-bubble-1-yash")
        if (firstBubbleIndicator) {
          firstBubbleIndicator.classList.add("interface-black-yash")
        }
      }
    }

    // Calculate the initial time that will show for the stopwatch
    const submitButton = document.getElementById("submit-yash")
    if (submitButton) {
      let sectionLength = submitButton.getAttribute("data-section-length")
      if (sectionLength && parseInt(sectionLength) < 10) {
        // If sectionLength is less than 10, we need to pad it with a zero
        sectionLength = "0" + sectionLength.toString()
      }
      const sectionLengthTimeString = sectionLength + ":00"
      const stopwatch = document.getElementById("stopwatch-yash")
      if (stopwatch) {
        stopwatch.innerHTML = sectionLengthTimeString
      }
    }
  }

  initializeOnLoad() {
    // Call resizePage on initial load
    this.resizePage()

    // Set text of start button
    const startButton = document.getElementById("interface-start-yash")
    if (startButton) {
      startButton.textContent = "Start"
    }

    // Call highlightFeature with image data to initialize highlight functionality
    // This sets up the highlight containers and makes highlight buttons functional
    // Safely get image data from script tag, defaulting to empty object if not available
    let imageData = undefined
    if (this.hasImageData()) {
      try {
        const scriptTag = document.getElementById('lsat-section-image-data')
        if (scriptTag && scriptTag.textContent) {
          const rawJson = scriptTag.textContent.trim()
          console.log('[lsat-section] Raw JSON from script tag:', rawJson.substring(0, 200))
          imageData = JSON.parse(rawJson)
          console.log('[lsat-section] Parsed imageData value:', imageData, 'Type:', typeof imageData, 'Keys:', imageData ? Object.keys(imageData) : 'none')
          // Ensure it's an object, not null or undefined
          if (!imageData || typeof imageData !== 'object') {
            console.warn('[lsat-section] imageData is not a valid object:', imageData)
            imageData = {}
          } else {
            // Filter out null/undefined values and check if we have any valid data
            const validKeys = Object.keys(imageData).filter(key => imageData[key] != null)
            console.log('[lsat-section] Valid imageData keys:', validKeys.length, validKeys.slice(0, 5))
            if (validKeys.length === 0) {
              console.warn('[lsat-section] imageData has no valid entries')
              imageData = {}
            }
          }
        } else {
          console.warn('[lsat-section] Script tag not found or empty')
          imageData = {}
        }
      } catch (e) {
        console.warn('[lsat-section] Error parsing imageData from script tag:', e)
        imageData = {}
      }
    } else {
      console.warn('[lsat-section] No imageData script tag available')
    }

    // Wait for images to load before initializing highlights
    // The highlight functionality needs naturalWidth/naturalHeight from images
    const initializeHighlights = () => {
      if (typeof window.highlightFeature === 'function') {
        // Check if imageData has any valid (non-null) entries
        let dataToPass = undefined
        if (imageData && typeof imageData === 'object') {
          const validKeys = Object.keys(imageData).filter(key => imageData[key] != null && imageData[key] !== undefined)
          if (validKeys.length > 0) {
            dataToPass = imageData
            console.log('[lsat-section] Calling highlightFeature with imageData:', validKeys.length, 'valid entries')
          } else {
            console.warn('[lsat-section] imageData exists but has no valid entries, skipping highlightFeature')
          }
        } else {
          console.warn('[lsat-section] No valid imageData, skipping highlightFeature')
        }

        if (dataToPass) {
          window.highlightFeature(dataToPass)
        } else {
          // Still call highlightFeature with undefined to set up button handlers
          // Even without image data, the highlight buttons should work
          console.log('[lsat-section] Calling highlightFeature with undefined (no image data, but will set up buttons)')
          window.highlightFeature(undefined)
        }
      } else {
        console.warn('[lsat-section] highlightFeature not available')
      }
    }

    // Check if images are loaded, if not wait for them
    const $ = window.$
    if ($) {
      // Wait for both setup and question images to load
      const checkImagesLoaded = () => {
        const firstSetupContainer = $("#interface-setup-container-1-yash")
        const firstQuestionContainer = $("#interface-questions-container-holder-1-yash")

        // Get setup image (for games/comp) or question image (for reasoning)
        let setupImage = null
        let questionImage = null

        if (firstSetupContainer.length) {
          const setupImgId = firstSetupContainer.find(".interface-cover-yash img.alt-field").attr('id')
          if (setupImgId) {
            setupImage = document.getElementById(setupImgId)
          }
        }

        if (firstQuestionContainer.length) {
          const questionImgId = firstQuestionContainer.find(".interface-cover-yash img.alt-field").attr('id')
          if (questionImgId) {
            questionImage = document.getElementById(questionImgId)
          }
        }

        // Check if images are loaded (need naturalWidth > 0)
        const setupLoaded = !setupImage || (setupImage.complete && setupImage.naturalWidth > 0)
        const questionLoaded = questionImage && questionImage.complete && questionImage.naturalWidth > 0

        // For reasoning sections, we only need question image
        // For games/comp, we need both
        if (setupImage) {
          // Games/comp section - need both images
          return setupLoaded && questionLoaded
        } else {
          // Reasoning section - only need question image
          return questionLoaded
        }
      }

      if (checkImagesLoaded()) {
        // Images already loaded
        initializeHighlights()
      } else {
        // Wait for images to load
        let attempts = 0
        const maxAttempts = 50 // 5 seconds max wait
        const checkInterval = setInterval(() => {
          attempts++
          if (checkImagesLoaded() || attempts >= maxAttempts) {
            clearInterval(checkInterval)
            initializeHighlights()
          }
        }, 100)
      }
    } else {
      // Fallback if jQuery not available - wait a bit then initialize
      setTimeout(initializeHighlights, 1000)
    }
  }

  resizePage() {
    const $ = window.$
    if (!$) {
      console.warn('[lsat-section] jQuery not available for resizePage')
      return
    }

    const windowWidth = $(window).width()
    const windowHeight = $(window).height()

    let ratio = 13 / 8
    if (windowWidth / windowHeight >= ratio) {
      // height dependent because width is larger than ratio's width
      const newWidth = windowHeight * ratio
      $(".interface-container-yash").css("width", newWidth)
      $(".interface-container-yash").css("height", windowHeight)

      $(".interface-test-yash").css("height", "82vh")
      $(".interface-bottom-bar-yash").css("height", "10vh")
    } else {
      // width dependent because height is larger than ratio's height
      const newHeight = windowWidth / ratio
      $(".interface-container-yash").css("height", newHeight)
      $(".interface-container-yash").css("width", windowWidth)
      $(".interface-test-yash").css("height", newHeight * 0.8)
      $(".interface-bottom-bar-yash").css("height", newHeight * 0.1)
    }

    // setting bottom bubble heights
    ratio = 18 / 24
    const bottomBubbleWidth = $(".interface-bottom-bubble-yash").width()
    $(".interface-bottom-bubble-yash").css("height", bottomBubbleWidth * ratio)
    $(".interface-bottom-bubble-wrap-yash").css(
      "fontSize",
      bottomBubbleWidth * ratio + 5
    )

    // setting the answer choice bubble heights
    ratio = 29.5 / 41
    const currentQuestion = window.currentQuestion || { number: 1 }
    const bubbleWidth = $(
      "#interface-questions-circle-" + currentQuestion.number + "-first-yash"
    ).width()
    if (bubbleWidth) {
      $(".interface-questions-circle-yash").css("height", bubbleWidth * ratio)
      $(".interface-questions-circle-yash").css(
        "fontSize",
        bubbleWidth * ratio - 6
      )
      $(".interface-elimination-circle-yash").css("height", bubbleWidth * ratio)
      $(".interface-elimination-circle-yash").css(
        "fontSize",
        bubbleWidth * ratio - 6
      )
    }

    // resize bottom buttons
    ratio = 50 / 70
    const arrowWidth = $(".interface-move-button-yash").width()
    if (arrowWidth) {
      $(".interface-move-button-yash").css("height", arrowWidth * ratio)
    }

    // set height to width of flag
    const flagElement = $("#flag-button-" + currentQuestion.number + "-first-yash")
    if (flagElement.length) {
      const flagWidth = flagElement.width()
      $(".flag-button-yash").css("height", flagWidth)
    }

    ratio = 14 / 21
    const bottomBubbleWidth2 = $(".interface-bottom-bubble-yash").width()
    if (bottomBubbleWidth2) {
      $(".interface-bottom-bubble-yash").css("height", ratio * bottomBubbleWidth2)
    }

    // resizing covers for images
    const questionWidth = $(
      "#interface-questions-container-holder-" +
        currentQuestion.number +
        "-yash"
    )
      .find(".interface-cover-yash img")
      .width()

    if (questionWidth) {
      const numQuestions = $(".interface-bottom-bubble-yash").length
      for (let i = 1; i <= numQuestions; i++) {
        const questionCovers = $(
          "#interface-questions-container-holder-" + i + "-yash"
        ).find(".interface-cover-yash img")
        if (questionCovers.length >= 2 && questionCovers[1].naturalHeight && questionCovers[1].naturalWidth) {
          const imgRatio = questionCovers[1].naturalHeight / questionCovers[1].naturalWidth
          $(questionCovers[0]).height(Math.ceil(questionWidth * imgRatio))
        }
      }
    }

    const setupWidth = $(
      "#interface-setup-container-" + currentQuestion.number + "-yash"
    )
      .find(".interface-cover-yash img")
      .width()

    if (setupWidth) {
      for (let i = 1; i <= $(".interface-setup-container-yash").length; i++) {
        const setupCovers = $("#interface-setup-container-" + i + "-yash").find(
          ".interface-cover-yash img"
        )
        if (setupCovers.length >= 2 && setupCovers[1].naturalHeight && setupCovers[1].naturalWidth) {
          const imgRatio = setupCovers[1].naturalHeight / setupCovers[1].naturalWidth
          const imgHeight = setupWidth * imgRatio
          $(setupCovers[0]).height(imgHeight)
        }
      }
    }
  }

  startTest(event) {
    if (event) {
      event.preventDefault()
    }

    const $ = window.$
    if (!$) {
      console.warn('[lsat-section] jQuery not available for startTest')
      return
    }

    // Hide pre-start cover
    $(".interface-pre-start-cover-yash").css("display", "none")
    // Remove filter from first question
    $("#interface-questions-container-holder-1-yash").css("filter", "none")
    // Remove start button
    $("#interface-start-yash").remove()
    // Remove filter from test area
    $(".interface-test-yash").css("filter", "none")

    // Get currentQuestion
    const currentQuestion = window.currentQuestion
    if (!currentQuestion) {
      console.error('[lsat-section] currentQuestion is not initialized')
      return
    }

    // Initialize GameTimer
    if (typeof window.GameTimerYash === 'function') {
      window.GameTimer = new window.GameTimerYash(currentQuestion)
    } else {
      console.warn('[lsat-section] GameTimerYash not available')
    }

    // Set timer cursor
    $(".interface-timer-yash").css("cursor", "pointer")

    // Enable keyboard controller
    const keyboardController = this.application.getControllerForElementAndIdentifier(
      document.querySelector('[data-controller*="section-keyboard"]'),
      'section-keyboard'
    )
    if (keyboardController && typeof keyboardController.enable === 'function') {
      keyboardController.enable()
    }

    // Set up timer click handler (if not already set up)
    const timerController = this.application.getControllerForElementAndIdentifier(
      document.querySelector('.interface-timer-yash'),
      'timer-toggle'
    )
    if (!timerController) {
      // Fallback: set up click handler directly if controller not found
      $(".interface-timer-yash").off('click').on('click', () => {
        const showAttr = $(".interface-timer-yash").attr("data-show")
        if (showAttr == "1") {
          $("#stopwatch-yash").addClass("interface-timer-hide-yash")
          $(".interface-progress-bar-yash").addClass("interface-timer-hide-yash")
          $(".interface-timer-yash").attr("data-show", "0")
        } else {
          $("#stopwatch-yash").removeClass("interface-timer-hide-yash")
          $(".interface-progress-bar-yash").removeClass("interface-timer-hide-yash")
          $(".interface-timer-yash").attr("data-show", "1")
        }
      })
    }
  }
}
